import { Tab } from "@headlessui/react";
import { TabNoData } from "../components/common/NoData";

import TextNavBackground from "../components/common/TextNavBackground";
import LeagueTable from "../components/elements/standings/LeagueTable";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kAllTablesURL } from "../utils/constants/apiUrls";
import { ONE_DAY_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import { customStaticSeoConfig, getApiToken } from "../utils/helpers/helpers";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const CompetitionStandings = ({ leagueTables }) => {
  const { season_title: seasonTitle, tables } = leagueTables;
  const {
    academy_tables: academyTables,
    men_tables: menTables,
    women_tables: womenTables,
  } = tables;

  return (
    <>
      {customStaticSeoConfig(`${seasonTitle} Competition Standings`)}
      <TextNavBackground title={`${seasonTitle} Competition Standings`} />

      <div className="block w-full text-base sm:text-sm">
        <Tab.Group>
          <Tab.List className="-mb-px flex justify-center items-center space-x-8 overflow-x-auto bg-gray-200">
            {/* <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Men
            </Tab>
            <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Women
            </Tab>
            <Tab
              className={({ selected }) =>
                classNames(
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none",
                  selected
                    ? "border-red-500 dark:border-green-500 text-red-600 dark:text-green-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 active:border-none"
                )
              }
            >
              Academy
            </Tab> */}
          </Tab.List>
          <Tab.Panels>
            {/** MEN TABLES TAB PANEL */}
            <Tab.Panel className="mt-10">
              {Object.keys(menTables).length === 0 && (
                <>
                  <TabNoData />
                </>
              )}

              {Object.keys(menTables).length !== 0 && (
                <>
                  <div className="block w-full text-base sm:text-sm">
                    <Tab.Group>
                      <Tab.List className="-mb-px flex justify-start sm:justify-center items-center space-x-8 overflow-x-auto pl-14 pr-14">
                        {Object.keys(menTables).map((table) => (
                          <Tab
                            key={table}
                            className={({ selected }) =>
                              classNames(
                                "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none",
                                selected
                                  ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                                  : "text-gray-500 hover:text-gray-700",
                              )
                            }
                          >
                            {table}
                          </Tab>
                        ))}
                      </Tab.List>
                      <Tab.Panels className="max-w-2xl mx-auto lg:max-w-7xl px-10">
                        {Object.values(menTables).map((table, index) => (
                          <Tab.Panel key={index}>
                            <LeagueTable table={table} />
                          </Tab.Panel>
                        ))}
                      </Tab.Panels>
                    </Tab.Group>
                  </div>
                </>
              )}
            </Tab.Panel>

            {/** WOMEN TABLES TAB PANEL */}
            {/* <Tab.Panel className="mt-10">
              {Object.keys(womenTables).length === 0 && (
                <>
                  <TabNoData />
                </>
              )}

              {Object.keys(womenTables).length !== 0 && (
                <>
                  <div className="block w-full text-base sm:text-sm">
                    <Tab.Group>
                      <Tab.List className="-mb-px flex justify-start sm:justify-center items-center space-x-8 overflow-x-auto pl-14 pr-14">
                        {Object.keys(womenTables).map((table) => (
                          <Tab
                            key={table}
                            className={({ selected }) =>
                              classNames(
                                "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none",
                                selected
                                  ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                                  : "text-gray-500 hover:text-gray-700"
                              )
                            }
                          >
                            {table}
                          </Tab>
                        ))}
                      </Tab.List>
                      <Tab.Panels className="max-w-2xl mx-auto lg:max-w-7xl px-10">
                        {Object.values(womenTables).map((table, index) => (
                          <Tab.Panel key={index}>
                            <LeagueTable table={table} />
                          </Tab.Panel>
                        ))}
                      </Tab.Panels>
                    </Tab.Group>
                  </div>
                </>
              )}
            </Tab.Panel> */}

            {/** ACADEMY TABLES TAB PANEL */}
            {/* <Tab.Panel className="mt-10">
              {Object.keys(academyTables).length === 0 && (
                <>
                  <TabNoData />
                </>
              )}

              {Object.keys(academyTables).length !== 0 && (
                <>
                  <div className="block w-full text-base sm:text-sm">
                    <Tab.Group>
                      <Tab.List className="-mb-px flex justify-start sm:justify-center items-center space-x-8 overflow-x-auto pl-14 pr-14">
                        {Object.keys(academyTables).map((table) => (
                          <Tab
                            key={table}
                            className={({ selected }) =>
                              classNames(
                                "whitespace-nowrap px-3 py-2 font-medium text-sm rounded-md focus:outline-none",
                                selected
                                  ? "bg-red-100 text-red-700 dark:bg-green-100 dark:text-green-700 active:border-none"
                                  : "text-gray-500 hover:text-gray-700"
                              )
                            }
                          >
                            {table}
                          </Tab>
                        ))}
                      </Tab.List>
                      <Tab.Panels className="max-w-2xl mx-auto lg:max-w-7xl px-10">
                        {Object.values(academyTables).map((table, index) => (
                          <Tab.Panel key={index}>
                            <LeagueTable table={table} />
                          </Tab.Panel>
                        ))}
                      </Tab.Panels>
                    </Tab.Group>
                  </div>
                </>
              )}
            </Tab.Panel> */}
          </Tab.Panels>
        </Tab.Group>
      </div>
    </>
  );
};

export default CompetitionStandings;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const tables = await apiWrapper.get(kAllTablesURL, token);

  return {
    props: {
      leagueTables: tables?.data,
    },
    revalidate: ONE_DAY_REFRESH_INTERVAL_SECONDS,
  };
};
